/* Slies Collection New Look — cart removal, delivery total, footer, pop-ups, policy pages */
(function () {
  var MINUS = '[on\\:click="/decreaseQuantity"]';
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var keepOpenUntil = 0;

  /* ---- Cart: minus on a quantity of 1 removes the item right away ---- */
  function enableMinus() {
    document.querySelectorAll(MINUS + '[disabled]').forEach(function (button) {
      button.removeAttribute('disabled');
    });
  }

  /* After the last item is removed the theme closes and re-draws the drawer.
     Hold it open so the shopper simply sees "Your cart is empty". */
  function holdDrawerOpen() {
    keepOpenUntil = Date.now() + 5000;
    document.documentElement.classList.add('slies-keepopen');
    setTimeout(function () { document.documentElement.classList.remove('slies-keepopen'); }, 5200);
    var component = document.querySelector('cart-drawer-component');
    if (component && !component.__sliesPatched && typeof component.close === 'function') {
      var original = component.close;
      component.close = function () {
        if (Date.now() < keepOpenUntil) return undefined;
        return original.apply(this, arguments);
      };
      component.__sliesPatched = true;
    }
  }

  /* Runs the moment the drawer's dialog is re-drawn closed. */
  function reopenDrawer() {
    if (Date.now() > keepOpenUntil) return;
    var dialog = document.querySelector('.cart-drawer__dialog');
    if (!dialog || dialog.open) return;
    if (dialog.showModal) dialog.showModal();
  }

  document.addEventListener('click', function (event) {
    /* The shopper chose to close the cart: let it close. */
    if (event.target.closest('.cart-drawer__close-button') || (event.target.classList && event.target.classList.contains('cart-drawer__dialog'))) keepOpenUntil = 0;

    var minus = event.target.closest(MINUS);
    if (minus) {
      var row = minus.closest('.cart-items__table-row, [ref="cartItemRows[]"]');
      if (row && !row.classList.contains('slies-removing')) {
        var input = row.querySelector('input[type="number"], input[name="updates[]"], input');
        var qty = input ? parseInt(input.value, 10) : NaN;
        var remove = row.querySelector('.cart-items__remove');
        if (qty === 1 && remove) {
          event.preventDefault();
          event.stopImmediatePropagation();
          var rows = row.closest('.cart-drawer__dialog, .cart-items-component, body').querySelectorAll('.cart-items__table-row[ref]').length;
          if (rows <= 1) holdDrawerOpen();
          row.classList.add('slies-removing');
          remove.click();
          return;
        }
      }
    }

    /* Footer menus stay open on desktop. */
    var title = event.target.closest('.slies-footer__nav-title');
    if (title && DESKTOP.matches) event.preventDefault();

    /* Review pop-up open / close. */
    var opener = event.target.closest('[data-slies-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-slies-open'));
      if (dialog && dialog.showModal) dialog.showModal();
      return;
    }
    var closer = event.target.closest('[data-slies-close]');
    if (closer) {
      var box = closer.closest('dialog');
      if (box) box.close();
      return;
    }
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('slies-rv')) event.target.close();
  }, true);

  /* ---- Empty cart: the button leads to all collections ---- */
  function emptyCartLinks() {
    var fix = function (root) {
      root.querySelectorAll('.cart-items__empty-button').forEach(function (link) {
        if (link.getAttribute('href') !== '/collections') link.setAttribute('href', '/collections');
      });
    };
    fix(document);
    var template = document.getElementById('empty-cart-template');
    if (template && template.content) fix(template.content);
  }

  /* ---- Total with delivery follows the selected variant's price ---- */
  function money(n) { return 'R' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function toNumber(text) {
    var m = /[\d][\d,\s]*(?:\.\d+)?/.exec(text || '');
    return m ? parseFloat(m[0].replace(/[,\s]/g, '')) : NaN;
  }

  /* The price of the product being viewed (not the cards in the menu or related products). */
  function mainPrice() {
    var list = document.querySelectorAll('.product-details .price');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getBoundingClientRect().width > 0) return toNumber(list[i].textContent);
    }
    return NaN;
  }

  function syncTotals() {
    var totals = document.querySelectorAll('.slies-pi-total');
    if (!totals.length) return;
    var price = mainPrice();
    if (isNaN(price)) return;
    totals.forEach(function (total) {
      var range = total.querySelector('.slies-pi-total__range');
      if (!range) return;
      if (!total.dataset.slieslow) {
        var parts = range.textContent.split(/\s+to\s+/);
        var low = toNumber(parts[0]);
        var high = toNumber(parts[1]);
        if (isNaN(low) || isNaN(high)) return;
        total.dataset.slieslow = String(low - price);
        total.dataset.slieshigh = String(high - price);
      }
      var text = money(price + Number(total.dataset.slieslow)) + ' to ' + money(price + Number(total.dataset.slieshigh));
      if (range.textContent !== text) range.textContent = text;
    });
  }

  /* ---- Footer: both menus open on desktop ---- */
  function footerMenus() {
    if (!DESKTOP.matches) return;
    document.querySelectorAll('.slies-footer__nav').forEach(function (d) { if (!d.open) d.open = true; });
  }

  /* ---- Policy pages: turn bold one-line paragraphs into headings, tidy leftovers ---- */
  function policyPages() {
    document.querySelectorAll('[data-slies-policy]:not([data-done])').forEach(function (body) {
      body.dataset.done = 'true';
      body.querySelectorAll('p').forEach(function (p) {
        var text = p.textContent.replace(/ /g, ' ').trim();
        if (!text && !p.querySelector('img')) { p.remove(); return; }
        var only = p.children.length === 1 && p.firstElementChild.tagName === 'STRONG' && p.firstElementChild.textContent.replace(/ /g, ' ').trim() === text;
        if (only) p.classList.add('slies-policy__h');
        p.removeAttribute('style');
      });
      body.querySelectorAll('br').forEach(function (br) { if (!br.nextSibling) br.remove(); });
    });
  }

  /* ---- Reopen the pop-up so the thank-you shows after sending ---- */
  function reopenAfterSend() {
    if (!/#SliesReview/.test(location.hash)) return;
    var dialog = document.querySelector('dialog.slies-rv');
    if (dialog && dialog.showModal && !dialog.open) dialog.showModal();
  }

  var queued = false;
  function run() {
    queued = false;
    enableMinus();
    syncTotals();
    footerMenus();
    emptyCartLinks();
    policyPages();
  }
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  }

  /* The drawer is re-opened in the same moment it is re-drawn, so there is no blink. */
  new MutationObserver(function () { reopenDrawer(); queue(); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'open'] });
  document.addEventListener('DOMContentLoaded', function () { queue(); reopenAfterSend(); });
  window.addEventListener('resize', queue);
  queue();
})();
